import { render } from "./view-service.vue?vue&type=template&id=c9a1e9e2"
import script from "./view-service.vue?vue&type=script&lang=js"
export * from "./view-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__